class Wishlist {
  constructor(el) {
    this.container = el
    this.cards = Array.from(this.container.querySelectorAll('.wishlist-card'))

    this.checkEmptyWishlist()
    this.init()
  }

  checkEmptyWishlist() {
    if (this.cards.length) {
      this.container.classList.remove('wishlist--empty')
    } else {
      this.container.classList.add('wishlist--empty')
    }
  }

  init() {
    this.cards.forEach((card, index) => {
      const form = card.querySelector('.wishlist-card__form')

      if (form) {
        form.addEventListener('submit', async e => {
          e.preventDefault()
          const { api } = window.suplementos
          const formData = new FormData(form)

          card.classList.add('wishlist-card--loading')

          const response = await fetch(`${api}/remove-from-wishlist`, {
            method: 'POST',
            credentials: 'include',
            body: formData,
          })

          if (response.ok) {
            const result = await response.json()
            const { error } = result

            if (!error) {
              this.cards.splice(index, 1)
              card.remove()
              this.checkEmptyWishlist()
            }
          }

          card.classList.add('wishlist-card--loading')
        })
      }
    })
  }
}

const wishlist = {
  // eslint-disable-next-line consistent-return
  init() {
    const wrapperEl = document.querySelectorAll('.wishlist')
    Array.from(wrapperEl).forEach(button => new Wishlist(button))
  },
}

export default wishlist
